import FlashLib from 'flashlib_onlyplay';

export default class SlotFrameContainer extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
  }
}
